import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { ChartHeaderProps } from './types';
import CustomTooltip from '../common/CustomTooltip';

/**
 * Reusable header component for all chart components
 * Displays title, description, and optional details tooltip
 */
const ChartHeader: React.FC<ChartHeaderProps> = ({ title, description, details }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
      <Box sx={{ flex: 1 }}>
        <Typography variant="h5" gutterBottom sx={{ textAlign: 'left', fontWeight: 700, color: '#0F172A', mb: 0.5 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'left', color: '#4B5563' }}>
          {description}
        </Typography>
      </Box>
      {details && (
        <CustomTooltip
          title={(
            <Box sx={{ maxWidth: 320 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {details?.tooltipDescription ?? description}
              </Typography>
              {details?.points && Array.isArray(details.points) && (
                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  {details.points.map((p: any, i: number) => (
                    typeof p === 'string' && (
                      <li key={i}>
                        <Typography variant="body2">{p}</Typography>
                      </li>
                    )
                  ))}
                </Box>
              )}
              {details?.tooltipPoints && Array.isArray(details.tooltipPoints) && (
                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  {details.tooltipPoints.map((p: any, i: number) => (
                    typeof p === 'string' && (
                      <li key={i}>
                        <Typography variant="body2">{p}</Typography>
                      </li>
                    )
                  ))}
                </Box>
              )}
            </Box>
          )}
          placement="bottom"
          arrow
        >
          <IconButton size="small" sx={{ ml: 1 }}>
            <InfoOutlined fontSize="small" />
          </IconButton>
        </CustomTooltip>
      )}
    </Box>
  );
};

export default ChartHeader;
